import logger from '../log';
import { HttpResponse, ResponseMapper } from './interfaces';
import { Item } from '../webrtc/agent/interfaces';
import PlaybackConfig from '../config/PlaybackConfig';
import { SourceType, PlayType } from '../common/constants';
import filterDashBitrates from '../common/dash/filterBitrates';
import filterHlsBitrates from '../hls/filterHlsBitrates';
import { isManifestMime, isManifestUrl } from '../common/utils/sourceTypeUtils';
import { isString, maybeDecode } from '../common/utils/stringify';
import { itemsContainUrl } from './itemsContainUrl';

const log = logger.getLogger(__filename);

function filterBitrates(
  data: string,
  playback: PlaybackConfig,
  sourceType: SourceType,
  playType: PlayType
) {
  switch (sourceType) {
    case SourceType.DASH:
      log.debug('filtering dash manifest:', { data, playback });
      return filterDashBitrates(data, playback);
    case SourceType.HLS:
      log.debug('filtering hls manifest:', { data, playback });
      return filterHlsBitrates(data, playback, playType);
    default:
      return data;
  }
}

const isManifest = (items: Item[], response: HttpResponse) => {
  const url = response.request.url;
  const mime = response.headers && response.headers.get('content-type');
  return (
    itemsContainUrl(items, url) ||
    (mime && isManifestMime(mime)) ||
    isManifestUrl(url)
  );
};

export default function maybeModifyManifest(
  items: Item[],
  playback: PlaybackConfig,
  sourceType: SourceType,
  playType: PlayType
): ResponseMapper {
  return response => {
    // if it's the manifest url, then it's likely the "data" is a string. But we don't want empty strings.
    if (
      // should be the manifest
      response.body &&
      // there should be data
      isManifest(items, response)
    ) {
      const { maybeEncode, data } = maybeDecode(response.body);
      if (isString(data)) {
        const body = filterBitrates(data, playback, sourceType, playType);
        response.body = maybeEncode(body);
      } else {
        log.info(`Unable to modify manifest ${response.request.url}`);
      }
    }
    return response;
  };
}
